import { SliceType } from '@/engine/app/modules/images/interfaces.ts';
import type { JSONConfig } from '@/engine/app/interfaces.ts';

const color = '#FF4E4E';
const selectionColor = '#FF0000';
const alongSliceDescriptor = SliceType.AXIAL;

export const leftVessel: JSONConfig.CenterLine = {
  descriptor: 'vessel.left_centerline',
  selectionColor,
  color,
  alongSliceDescriptor
};

export const rightVessel: JSONConfig.CenterLine = {
  descriptor: 'vessel.right_centerline',
  selectionColor,
  color,
  alongSliceDescriptor
};

export const longAxis: JSONConfig.CenterLine = {
  descriptor: 'long_axis.centerline',
  selectionColor: '#00FF00',
  color: '#4EFF4E',
  alongSliceDescriptor: SliceType.SAGITTAL
};
